<div [formGroup]="theForm">
    <mat-form-field
        [appearance]="isEmbedded ? 'standard' : 'outline'"
        [ngClass]="{ 'text-input-field-wrapper': isEmbedded || isFullWidthField }"
    >
        <mat-label>{{ metaData?.friendlyName || metaData?.name }}</mat-label>
        <input
            [type]="metaData?.type"
            autocomplete="off"
            matInput
            [placeholder]="metaData?.friendlyName || metaData?.name"
            [formControlName]="metaData?.inputName"
            (blur)="onBlurHandler()"
            [readonly]="checkReadonly()"
            (click)="turnOffReadonly($event)"
            (focus)="turnOffReadonly($event)"
            [required]="notRequired === 'false'"
        />
        <mat-hint>{{ metaData?.description }}</mat-hint>
        <mat-error>
            <span *ngIf="getErrors() as errors">{{ errors }}</span>
        </mat-error>
    </mat-form-field>
</div>
